import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=0d47d700"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports